export const LOGO_URL = "/marsu.png";

export const siteConfig = {
  coinName: "MARSUPILAMI",
  coinTicker: "MRS",
  logoUrl: LOGO_URL,
  tagline: "Huba Huba! To The Moon With The King of the Jungle!",
  description: "The most powerful hero of the jungle is now in the crypto world!",
  socialLinks: {
    telegram: "https://t.me/marpicoin",
    twitter: "https://x.com/marpicoinn?s=21",
    discord: "#",
    instagram: "#",
  },
};

export const presaleConfig = {
  price: 0.000055,
  endDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
  paymentMethods: ["USDT", "USDC"],
  raised: 1250000,
  target: 5000000,
  isLive: true,
  tokensForSale: 350000000,
};

export const aboutData = {
  title: "MARSUPILAMI'S HOME",
  description:
    "MARSUPILAMI COIN rises from the ashes of worthless meme coins! We promise a transparent, community-driven, and rug-pull-free journey. With Marsupilami's legendary energy and the power of its magnificent tail, we're shaking up the crypto world! HUBA HUBA!",
};

export const featuresData = [
  {
    id: 1,
    title: "SAFE & SECURE",
    description: "With locked liquidity and a transparent team, we offer a rug-pull-free environment.",
    icon: "Shield",
  },
  {
    id: 2,
    title: "COMMUNITY DRIVEN",
    description: "MARSUPILAMI is for the people. Key decisions will be made by the community through our future DAO.",
    icon: "Users",
  },
  {
    id: 3,
    title: "DEFLATIONARY",
    description: "A 1% burn tax on every transaction ensures the total supply of MRS decreases over time.",
    icon: "Flame",
  },
  {
    id: 4,
    title: "POWERFUL MEMES",
    description: "Combining Marsupilami's legendary energy to become the most viral meme coin in crypto!",
    icon: "Zap",
  },
  {
    id: 5,
    title: "VIRAL MARKETING",
    description: "Aggressive marketing campaigns with top influencers and trending pushes on major platforms.",
    icon: "Megaphone",
  },
  {
    id: 6,
    title: "STAKING REWARDS",
    description: "Our long-term vision includes a staking platform where you can earn passive income with your MRS.",
    icon: "Coins",
  },
];

export const howToBuyData = [
  {
    id: 1,
    step: 1,
    title: "CONNECT WALLET",
    description: 'Use the "Connect Wallet" button in our presale section. Choose your preferred wallet (e.g., MetaMask, Trust Wallet) and approve the connection.',
  },
  {
    id: 2,
    step: 2,
    title: "GET ENOUGH BNB",
    description: "Make sure you have enough BNB in your wallet to cover the token purchase plus the required network transaction fees (gas).",
  },
  {
    id: 3,
    step: 3,
    title: "CONFIRM IN WALLET",
    description: 'Enter the amount of BNB you want to spend, click "Buy Now," and a confirmation prompt will appear in your wallet. Approve it to complete the purchase.',
  },
];

export const tokenomicsData = {
  contractAddress: "0xTBA...MARSUPILAMI",
  totalSupply: 500000000,
  ticker: "MRS",
  distribution: [
    { name: "Presale", percentage: 70, color: "#FFD700" },
    { name: "Liquidity", percentage: 15, color: "#2ecc71" },
    { name: "Marketing", percentage: 8, color: "#f39c12" },
    { name: "Community Airdrop", percentage: 5, color: "#3498db" },
    { name: "Team", percentage: 2, color: "#9b59b6" },
  ],
};

export const roadmapData = [
  {
    id: 1,
    phase: "Phase 1",
    status: "done",
    items: ["Contract Creation", "Website v1 Launch", "Social Media Launch", "Airdrop 1.0: For early supporters"],
  },
  {
    id: 2,
    phase: "Phase 2",
    status: "done",
    items: ["Marketing Partnerships", "Meme Contests", "Listing Applications (CMC/CG)", "Airdrop 2.0"],
  },
  {
    id: 3,
    phase: "Phase 3",
    status: "live",
    items: ["Push for Trending", "NFT Collection Launch", "Intensive Marketing", "Website v2 with Staking", "Token Burn Event"],
  },
  {
    id: 4,
    phase: "Phase 4",
    status: "upcoming",
    items: ["Community Governance (DAO)", "New Strategic Partnerships", "Ecosystem Expansion"],
  },
];

export const faqData = [
  {
    id: 1,
    question: "What is MARSUPILAMI COIN?",
    answer: "MARSUPILAMI COIN is the ultimate meme coin inspired by the legendary cartoon hero Marsupilami. It's a community-driven project focused on transparency, fun, and a journey to the Moon! HUBA HUBA!",
  },
  {
    id: 2,
    question: "Is the project safe?",
    answer: "Yes. Safety is our top priority. The liquidity pool is locked, and the contract is transparent. We are committed to creating a secure, rug-pull-free environment for our community.",
  },
  {
    id: 3,
    question: "What is the utility of the $MRS token?",
    answer: "The primary utility of $MRS is to be part of a vibrant, meme-loving community. Future utilities include participation in our DAO for governance, staking for passive rewards, and access to exclusive NFT collections.",
  },
  {
    id: 4,
    question: "When will the project launch?",
    answer: "The official launch on PancakeSwap is scheduled to happen right after the presale concludes. Stay tuned to our official Twitter and Telegram channels for the exact date and time announcement!",
  },
];

export const partnersData = [
  { name: "CoinMarketCap", logo: "CMC" },
  { name: "CoinGecko", logo: "CG" },
  { name: "Binance", logo: "BNB" },
  { name: "MEXC", logo: "MEXC" },
  { name: "Bitget", logo: "BG" },
  { name: "PancakeSwap", logo: "PCS" },
  { name: "Ethereum", logo: "ETH" },
];

export const marqueeTexts = [
  "100% Safe & Fun",
  "HUBA HUBA!",
  "100% Safe & Fun",
  "HUBA HUBA!",
  "100% Safe & Fun",
  "HUBA HUBA!",
];

export const depositWallets = [
  { name: "Tether (Bep-20)", address: "0x09fD3083ae2fd0CEB3324Cd143d3FcC48E8b9d87a" },
  { name: "BnB (Bep-20)", address: "0x09fD3083ae2fd0CEB3324Cd143d3FcC48E8b9d87a" },
  { name: "USDT (Trc-20)", address: "TZ2KyYfG5sDg88NCkv4JAybhpb9wMYobo7" },
  { name: "Eth (Bep-20)", address: "0x09fD3083ae2fd0CEB3324Cd143d3FcC48E8b9d87a" },
];

export const airdropTasks = [
  { id: 1, task: "Follow @MarsupilamiCoin on X", reward: 5000 },
  { id: 2, task: "Retweet the pinned post", reward: 2000 },
  { id: 3, task: "Join Telegram group", reward: 3000 },
];
